import { AppType } from '@tsq-web/core';
import { Platform } from './platform.enum';

export class LoginApplication {
  name: AppType;
  platform: Platform;
  version: string;
  deviceToken: string;
}
